import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import asyncAction, { isSuccessful } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import templateWeeks from 'modules/shift_management/store/api/collections/templateWeeks'

interface Props {
  shiftTemplateId: string
  onClose: () => void
}

const AddWeek = ({ shiftTemplateId, onClose }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const [running, setRunning] = React.useState(false)

  const form = useLazyRef<Form>(
    () =>
      new Form(
        {
          name: null,
          template_id: shiftTemplateId,
        },
        {
          name: 'string',
          template_id: 'string',
        }
      )
  ).current

  const onSubmit = async () => {
    setRunning(true)

    const result = await asyncAction(() => {
      return templateWeeks.create(form.data())
    })
    setRunning(false)

    if (isSuccessful(result)) {
      navigate(
        navigation.shifts.templates.templatesShiftTemplateId.edit.weeksWeekIdEdit.fullPath({
          shiftTemplateId: shiftTemplateId.toString(),
          weekId: result.value.id.toString(),
        })
      )
    }
  }

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('shift_management.rotating_shifts.schedules.add')}
      description={i18n.t('shift_management.rotating_shifts.schedules.modal_description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running || !form.isDirty} type="primary" submit>
            {i18n.t('common.next')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <TextInput
          label={i18n.t('shift_management.rotating_shifts.schedules.name')}
          placeholder={i18n.t('shift_management.rotating_shifts.schedules.modal_placeholder')}
          field={form.get('name')}
        />
      </Box>
    </Modal>
  )
}

export default observer(AddWeek)
